if (!customElements.get('cart-upsells')) {
	customElements.define(
		'cart-upsells',
		class CartUpsells extends HTMLElement {
			constructor() {
				super();
			}
			
			connectedCallback() {
				const waitForThemeScripts = () => {
					if (window.jQuery && typeof window.theme?.initComponents === 'function') {
						const sourceMode = this.dataset.sourceMode;
						if (sourceMode === 'static') {
							this.attachUpsellListeners();
							this.proactivelyFetchAllOptions();
						} else {
							this.listContainer = this.querySelector('.cart-upsells__list');
							this.dataScript = this.querySelector('#cart-products-data');
							this.boundRender = this.render.bind(this);
							this.render();
							document.addEventListener('cart:updated', this.boundRender);
						}
					} else {
						setTimeout(waitForThemeScripts, 50);
					}
				}
				
				waitForThemeScripts();
			}
			
			disconnectedCallback() {
				document.removeEventListener('cart:updated', this.boundRender);
			}
			
			sendUpsellEvent(upsellItem, event_name) {
				if (typeof gtag !== 'function') {
					console.warn('gtag() is not defined. GA event not sent.');
					return;
				}
				
				const product = upsellItem.baseProductData;
				
				if (!product) {
					console.error(`GA4 Event Error: Product data is missing for ${upsellItem.dataset.handle}. Event "${event_name}" was not sent.`);
					return;
				}
				
				const variantId = upsellItem.dataset.selectedVariantId;
				const variant = product.variants.find(v => v.id == variantId) || product.variants[0];
				
				const eventParams = {
					"event_category": "Cart Upsell",
					"event_label": `${product.title} - ${variant.title}`,
					"currency": window.theme.shop_currency,
					"value": variant.price / 100.0,
					"item_id": variant.sku || variant.id,
					"item_name": product.title,
					"item_variant": variant.title,
					"price": variant.price / 100.0,
					"quantity": 1,
					"upsell_source": "Cart Upsell"
				};
				
				console.log('eventParams', eventParams)
				gtag('event', event_name, eventParams);
			}
			
			async fetchFallbackProducts(tagsQuery) {
				try {
					const searchUrl = `/search?q=${encodeURIComponent(tagsQuery)}&type=product&view=json`;
					const response = await fetch(searchUrl);
					const data = await response.json();
					return data.products || [];
				} catch (error) {
					console.error('Error fetching fallback products:', error);
					return [];
				}
			}
			
			async fetchProductHtml(handle) {
				try {
					// ?sections=upsell-product-form
					const urlParams = new URLSearchParams(window.location.search);
					const currentView = urlParams.get('view');
					let fetchUrl = `${Shopify.routes.root}products/${handle}`;
					if (currentView) {
						fetchUrl += `?view=${currentView}`;
					}
					
					const response = await fetch(fetchUrl);
					if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
					
					// const jsonResponse = await response.json();
					// const htmlString = jsonResponse['upsell-product-form'];
					const htmlString = await response.text();
					const parser = new DOMParser();
					const doc = parser.parseFromString(htmlString, 'text/html');
					const productSection = doc.querySelector('.section-product-template .product-area');
					
					return productSection;
				} catch (error) {
					if (error.name !== 'AbortError') console.error('Failed to fetch product HTML:', error);
					return null;
				}
			}
			
			async fetchBaseProductData(handle) {
				try {
					const url = `/products/${handle}?sections=product-base-json`;
					
					const response = await fetch(url);
					if (!response.ok) return null;
					
					const sectionsData = await response.json();
					const jsonString = sectionsData['product-base-json'];
					
					const tempDiv = document.createElement('div');
					tempDiv.innerHTML = jsonString;
					return JSON.parse(tempDiv.textContent)
				} catch (e) {
					console.error("Failed to fetch optimized base data:", e);
					return null;
				}
			}
			
			async render() {
				const cartResponse = await fetch('/cart.js');
				const cart = await cartResponse.json();
				
				if (cart.item_count === 0) {
					this.style.display = 'none';
					return;
				}
				
				let cartProductsData = [];
				
				try {
					const sectionsResponse = await fetch(`${theme.routes.cart_url}?sections=cart-json`);
					const sectionsData = await sectionsResponse.json();
					const jsonString = sectionsData['cart-json'];
					
					const tempDiv = document.createElement('div');
					tempDiv.innerHTML = jsonString;
					cartProductsData = JSON.parse(tempDiv.textContent).items;
					
				} catch (e) {
					console.error("Failed to fetch fresh cart data via section API, using stale data as fallback:", e);
					if (!this.dataScript) return;
					cartProductsData = JSON.parse(this.dataScript.textContent);
				}
				
				const allTagsInCart = cartProductsData.flatMap(p => p.tags);
				const hasFountain = allTagsInCart.includes('kolo_tino_fountain');
				const hasBallpoint = allTagsInCart.includes('kolo_tino_ballpoint');
				let koloTinoUpsell = null;
				
				if (hasFountain && !hasBallpoint) {
					const fetched = await this.fetchFallbackProducts('tag:kolo_tino_ballpoint');
					if (fetched && fetched.length > 0) koloTinoUpsell = fetched[0];
				} else if (hasBallpoint && !hasFountain) {
					const fetched = await this.fetchFallbackProducts('tag:kolo_tino_fountain');
					if (fetched && fetched.length > 0) koloTinoUpsell = fetched[0];
				}
				
				if (koloTinoUpsell) {
					koloTinoUpsell.custom_upsell_message = window.theme?.strings?.koloTinoUpsellMessage || "Add the matching pen to get 20% off";
					koloTinoUpsell.discount_percentage = 20;
				}
				
				const cartHasJournal = allTagsInCart.includes('leather_journal') || allTagsInCart.includes('mimeeq-custom');
				const cartHasBundle = allTagsInCart.includes('bundle');
				const cartHasRefills = allTagsInCart.includes('refills');
				const cartHasAccessories = allTagsInCart.includes('accessories');
				
				let potentialUpsells = [];
				let fallbackQuery = null;
				
				const bundleComponentHandles = cartHasBundle
					? new Set(cartProductsData.filter(p => p.tags.includes('bundle')).flatMap(bundle => bundle.bundle_component_handles || []))
					: new Set();
				
				if (cartHasBundle) {
					const bundleProducts = cartProductsData.filter(p => p.tags.includes('bundle'));
					potentialUpsells = bundleProducts.flatMap(item => item.priority_upsells || []);
					
					fallbackQuery = '(tag:accessories OR tag:refills) AND tag:to_upsell';
				} else if (cartHasJournal && cartHasRefills) {
					potentialUpsells = await this.fetchFallbackProducts('tag:accessories AND tag:to_upsell');
				} else if (cartHasJournal) {
					const journalProducts = cartProductsData.filter(p => p.tags.includes('leather_journal') || p.tags.includes('mimeeq-custom'));
					potentialUpsells = journalProducts.flatMap(item => item.priority_upsells || []);
					
					fallbackQuery = 'tag:refills AND tag:to_upsell';
				} else if (cartHasRefills || cartHasAccessories) {
					const itemsToGetUpsellsFrom = cartProductsData.filter(p => p.tags.includes('refills') || p.tags.includes('accessories'));
					potentialUpsells = itemsToGetUpsellsFrom.flatMap(item => item.priority_upsells || []);
					
					fallbackQuery = '(tag:accessories OR tag:refills) AND tag:to_upsell';
				}
				
				const cartProductIds = cart.items.map(item => item.product_id);
				const uniqueUpsells = Array.from(
					new Map(potentialUpsells.map(product => [product.id, product])).values()
				);
				
				let finalUpsells = uniqueUpsells.filter(upsell => upsell.available === true && !cartProductIds.includes(upsell.id) && !bundleComponentHandles.has(upsell.handle));
				
				if (finalUpsells.length === 0 && fallbackQuery) {
					const fallbackProducts = await this.fetchFallbackProducts(fallbackQuery);
					finalUpsells = fallbackProducts.filter(upsell => upsell.available === true && !cartProductIds.includes(upsell.id) && !bundleComponentHandles.has(upsell.handle));
				}
				
				if (koloTinoUpsell && koloTinoUpsell.available) {
					finalUpsells = finalUpsells.filter(u => u.id !== koloTinoUpsell.id);
					finalUpsells.unshift(koloTinoUpsell);
				}
				
				const candidates = finalUpsells.slice(0, 6);
				let validatedUpsells = [];
				const baseDataResults = await Promise.all(
					candidates.map(upsell => this.fetchBaseProductData(upsell.handle))
				);
				
				for (let i = 0; i < candidates.length; i++) {
					if (validatedUpsells.length >= 3) break;
					
					const upsell = candidates[i];
					const baseData = baseDataResults[i];
					
					if (baseData) {
						if (baseData.bundle_available === false) {
							continue;
						}
						upsell.preloadedBaseData = baseData;
					}
					validatedUpsells.push(upsell);
				}
				
				this.renderUpsellHtml(validatedUpsells);
				
				if (validatedUpsells.length !== 0) {
					this.proactivelyFetchAllOptions();
				}
			}
			
			renderUpsellHtml(products) {
				if (!this.listContainer) return;
				this.listContainer.innerHTML = '';
				
				if (products.length === 0) {
					this.style.display = 'none';
					return;
				}
				this.style.display = 'block';
				
				let productsHtml = products.map(product => {
					const firstVariant = product.variants.find(v => v.available) || product.variants[0];
					const firstVariantPrice = product.price_varies ? product.price_min : product.variants[0].price;
					
					let priceHtml = '';
					if (product.discount_percentage) {
						const discountedPrice = firstVariantPrice * (1 - (product.discount_percentage / 100));
						const oldPriceFormatted = theme.Shopify.formatMoney(firstVariantPrice, theme.money_format_with_code_preference);
						const newPriceFormatted = theme.Shopify.formatMoney(discountedPrice, theme.money_format_with_code_preference);
						
						priceHtml = `
				     <s style="margin-right: 6px;">${oldPriceFormatted}</s>
				     <span class="sale-price" style="color: #af2e2e; font-weight: 600;">${newPriceFormatted}</span>
				    `;
					} else {
						priceHtml = theme.Shopify.formatMoney(firstVariantPrice, theme.money_format_with_code_preference);
					}
					
					const image = product.featured_image ? { src: product.featured_image, alt: product.title } : { src: '...', alt: 'placeholder' };
					const buttonText = theme.strings.buttonDefault;
					const selectOption = theme.strings.selectOption || 'Select Option';
					const priceFrom = theme.strings.priceFrom;
					const hasOneVariant = product.variants.length == 1;
					const customMessageHtml = product.custom_upsell_message
						? `<div class="upsell-item__custom-message">${product.custom_upsell_message}</div>`
						: '';
					
					return `
						<div class="upsell-item" data-discount-percentage="${product.discount_percentage || 0}" data-handle="${product.handle}" data-product-id="${product.id}" data-selected-variant-id="${firstVariant.id}" data-has-one-variant="${hasOneVariant}" ${hasOneVariant ? 'data-options-viewed="true"' : ''}>
					  	<div class="upsell-item__main-info">
					   	<a data-cc-animate-click href="${Shopify.routes.root}products/${product.handle}">
					    	<img class="upsell-item__image" src="${image.src}" alt="${image.alt}" width="82" height="82" loading="lazy">
					    </a>
					   	<div class="upsell-item__details">
					    	<div class="upsell-item__details-main">
					    		${customMessageHtml}
						      <a data-cc-animate-click href="${Shopify.routes.root}products/${product.handle}">
						        <span class="upsell-item__title">${product.title}</span>
						      </a>
						      <div class="upsell-item__price">
						        <span class="theme-money">
						          ${product.price_varies ? `${priceFrom} ` : ''}${priceHtml}
						       </span>
						      </div>
						      ${!hasOneVariant ? `
						        <div class="cc-accordion" data-allow-multi-open="false" data-components="accordion">
											<details class="cc-accordion-item upsell-item__accordion">
						            <summary class="cc-accordion-item__title upsell-item__select-options">
							            <span class="select-options__text">${selectOption}</span>
							            <span class="select-options__arrow">
							              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path d="M5.6416 8.43323L10.1416 12.9332L14.6416 8.43323" stroke="#5E5C5C" stroke-width="1.66667" stroke-miterlimit="8" stroke-linecap="round"/></svg>
							            </span>
		                    </summary>
				                <div class="cc-accordion-item__panel">
				                  <div class="cc-accordion-item__content upsell-item__options-container"></div>
				                </div>
				              </details>
	                  </div>
		              ` : `
						        <div class="upsell-item__options-container" style="display: none"></div>
						        ${product.variants[0].title !== 'Default Title' ? `
						          <span class="product-variant">${product.options[0]}: ${product.variants[0].title}</span>
						        ` : ''}
						      `}
					    	</div>
					    	<button type="button" class="button upsell-item__add-to-cart">${buttonText}</button>
					    </div>
					  </div>
					</div>`;
				}).join('');
				
				this.listContainer.innerHTML = productsHtml;
				this.attachUpsellListeners();
			}
			
			proactivelyFetchAllOptions() {
				this.querySelectorAll('.upsell-item').forEach(upsellItem => {
					const handle = upsellItem.dataset.handle;
					if (handle && !upsellItem.dataset.contentState) {
						this.loadOptionsContent(upsellItem, handle);
					}
				});
			}
			
			async loadOptionsContent(upsellItem, handle) {
				upsellItem.dataset.contentState = 'loading'
				
				const poolItem = this.upsellsPool ? this.upsellsPool.find(u => u.handle === handle) : null;
				
				const productSectionHtmlPromise = this.fetchProductHtml(handle);
				const baseProductDataPromise = poolItem && poolItem.preloadedBaseData
					? Promise.resolve(poolItem.preloadedBaseData)
					: this.fetchBaseProductData(handle);
				
				const [productSectionHtml, baseProductData] = await Promise.all([
					productSectionHtmlPromise,
					baseProductDataPromise
				]);
				
				if (baseProductData) {
					try {
						const rate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate)
							? parseFloat(window.Shopify.currency.rate)
							: 1.0;

						if (rate !== 1.0) {
							baseProductData.price = Math.round(baseProductData.price / rate);

							baseProductData.variants.forEach(variant => {
								variant.price = Math.round(variant.price / rate);
							});
						}
					} catch (e) {
						console.error("Error converting currency:", e);
					}
					
					upsellItem.baseProductData = baseProductData;
				}
				
				if (!productSectionHtml) {
					upsellItem.dataset.contentState = 'error';
					return;
				}
				
				const productJsonScript = productSectionHtml.querySelector(`script[id^="cc-product-json-"]`);
				let productJSON = null;
				if (productJsonScript) {
					try {
						productJSON = JSON.parse(productJsonScript.textContent);
						upsellItem.productData = productJSON;
					} catch(e) {
						console.error('Failed to parse product JSON:', e);
					}
				}
				if (productJSON && productJSON.tags.includes('paper_refills')) {
					const swatchContainers = productSectionHtml.querySelectorAll('.cc-swatches');
					swatchContainers.forEach(container => {
						container.classList.remove('cc-swatches', 'cc-swatches-prod-img');
					});
				}
				
				productSectionHtml.querySelector('.product-area__details__title')?.remove();
				productSectionHtml.querySelector('.product-inventory-notice')?.remove();
				productSectionHtml.querySelector('.store-availability-container-outer')?.remove();
				productSectionHtml.querySelectorAll('[data-show-in-quickbuy="false"]')?.forEach(el => el.remove());
				productSectionHtml.querySelector('.product-area__media')?.remove();
				productSectionHtml.querySelector('.klaviyo-popup-wrapper')?.remove();
				productSectionHtml.querySelector('.product-area__rich-text-block')?.remove();
				productSectionHtml.querySelectorAll('.product-detail-accordion')?.forEach(item => item.remove())
				productSectionHtml.querySelector('.product-detail__trust-icons')?.remove();
				productSectionHtml.querySelector('.product-detail__more_details')?.remove();
				productSectionHtml.querySelectorAll('.size-chart-container').forEach(el => el.remove());
				productSectionHtml.querySelector('.cc-rating-container')?.remove();
				productSectionHtml.querySelector('.product-area__details__header')?.removeAttribute('data-cc-animate');
				
				const scopePrefix = upsellItem.dataset.productId
					? `.upsell-item[data-product-id="${upsellItem.dataset.productId}"]`
					: `.upsell-item`;
				
				const injectedStyles = productSectionHtml.querySelectorAll('style');
				injectedStyles.forEach(style => {
					style.textContent = style.textContent.replace(/(^|\})\s*([^{]+)\s*\{/g, function(match, bracket, selectors) {
						if (selectors.trim().startsWith('@')) return match;
						const scopedSelectors = selectors.split(',').map(s => `${scopePrefix} ` + s.trim()).join(', ');
						return bracket + '\n' + scopedSelectors + ' {';
					});
				});
				
				const optionsContainer = upsellItem.querySelector('.upsell-item__options-container');
				if (optionsContainer) {
					optionsContainer.innerHTML = '';
					optionsContainer.appendChild(productSectionHtml);
				}
				
				upsellItem.dataset.contentState = 'loaded';
				if (!upsellItem.dataset.scriptsInitialized) {
					this.initializeScripts(upsellItem, productJSON || upsellItem.productData);
				}
			}
			
			attachUpsellListeners() {
				this.querySelectorAll('.upsell-item').forEach(upsellItem => {
					const accordion = upsellItem.querySelector('.upsell-item__accordion');
					const selectOptionBtn = upsellItem.querySelector('.upsell-item__select-options');
					const addToCartBtn = upsellItem.querySelector('.upsell-item__add-to-cart');
					theme.initComponents($(upsellItem));
					
					const productLinks = upsellItem.querySelectorAll('.upsell-item__main-info a');
					productLinks.forEach(link => {
						link.addEventListener('click', () => {
							this.sendUpsellEvent(upsellItem, 'upsell_view');
						});
					});
					
					if (selectOptionBtn) {
						accordion.addEventListener('toggle', () => {
							this.handleSelectOptionsClick(accordion);
							
							this.sendUpsellEvent(upsellItem, 'upsell_view');
						});
					}
					
					if (addToCartBtn) {
						addToCartBtn.addEventListener('click', (e) => {
							const hasOptions = upsellItem.dataset.hasOneVariant !== 'true';
							
							if (hasOptions && upsellItem.dataset.optionsViewed !== 'true') {
								e.preventDefault();
								e.stopPropagation();
								selectOptionBtn.click();
								return;
							}
							
							const optionsContainer = upsellItem.querySelector('.upsell-item__options-container');
							const form = optionsContainer.querySelector('.product-purchase-form');
							const internalAtcButton = form?.querySelector('[name="add"]');
							
							if (internalAtcButton) {
								const baseData = upsellItem.baseProductData;
								const variantId = upsellItem.dataset.selectedVariantId;
								
								if (baseData && variantId) {
									const baseVariant = baseData.variants.find(v => v.id == variantId);
									if (baseVariant) {
										let priceInput = form.querySelector('input[name="properties[_upsell_price_eur]"]');
										if (!priceInput) {
											priceInput = document.createElement('input');
											priceInput.type = 'hidden';
											priceInput.name = 'properties[_upsell_price_eur]';
											form.appendChild(priceInput);
										}
										priceInput.value = baseVariant.price;
									}
								}
								
								let sourceInput = form.querySelector('input[name="properties[_upsell_source]"]');
								if (!sourceInput) {
									sourceInput = document.createElement('input');
									sourceInput.type = 'hidden';
									sourceInput.name = 'properties[_upsell_source]';
									sourceInput.value = 'Cart Upsell';
									form.appendChild(sourceInput);
								}
								
								addToCartBtn.innerHTML = theme.strings.productAddingToCart;
								internalAtcButton.click();
								addToCartBtn.disabled = true;
								
								this.sendUpsellEvent(upsellItem, 'add_to_cart_upsell');
							} else {
								console.error('Internal ATC button not found inside the options container!');
							}
						});
					}
				});
			}
			
			handleSelectOptionsClick(accordion) {
				const upsellItem = accordion.closest('.upsell-item');
				const selectOptionText = upsellItem.querySelector('.upsell-item__select-options .select-options__text');
				const externalPriceElement = upsellItem.querySelector('.upsell-item__price');
				
				if (!upsellItem.dataset.optionsViewed) {
					upsellItem.dataset.optionsViewed = 'true';
					
					if (upsellItem.dataset.scriptsInitialized === 'true' && upsellItem.productData) {
						const currentVariantId = upsellItem.dataset.selectedVariantId;
						const variant = upsellItem.productData.variants.find(v => v.id == currentVariantId);
						
						if (variant && selectOptionText) {
							selectOptionText.textContent = variant.title;
						}
						
						const optionsContainer = upsellItem.querySelector('.upsell-item__options-container');
						const internalPriceArea = optionsContainer?.querySelector('.price-area');
						if (internalPriceArea && externalPriceElement) {
							this.updateExternalPrice(upsellItem);
						}
					}
				}
				
				if (accordion.open) {
					const optionsContainer = upsellItem.querySelector('.upsell-item__options-container');
					const contentState = upsellItem.dataset.contentState;
					
					if (contentState === 'loading') {
						optionsContainer.innerHTML = `
				            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
				                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
				            </svg>
			            `;
					}
					
					if (contentState === 'loaded' && !upsellItem.dataset.scriptsInitialized) {
						this.initializeScripts(upsellItem);
					}
				}
			}
			
			initializeScripts(upsellItem, productJSON) {
				upsellItem.dataset.scriptsInitialized = 'true';
				const optionsContainer = upsellItem.querySelector('.upsell-item__options-container');
				const sectionToInit = optionsContainer.querySelector('[data-section-type="product-template"]');
				const selectOptionText = upsellItem.querySelector('.upsell-item__select-options .select-options__text');
				const addToCartBtn = upsellItem.querySelector('.upsell-item__add-to-cart');
				const externalImage = upsellItem.querySelector('.upsell-item__image');
				if (!productJSON) {
					const productJsonScript = optionsContainer.querySelector(`script[id^="cc-product-json-"]`);
					try {
						productJSON = JSON.parse(productJsonScript.textContent);
					} catch(e) {
						console.error('Failed to parse product JSON:', e);
					}
				}
				
				if (sectionToInit && productJSON) {
					try {
						sectionToInit.setAttribute('data-is-modal-product', true);
						theme.ProductTemplateSection.onSectionLoad(sectionToInit, true);
						theme.initComponents($(sectionToInit));
						
						if (productJSON.options && Array.isArray(productJSON.options) && productJSON.options.length > 1) {
							window.optionsMap[productJSON.handle] = {};
							window.Shopify.linkOptionSelectors(productJSON, $(optionsContainer));
						}
					} catch (error) {
						console.warn('Theme script initialization failed for product:', productJSON.handle, error);
					}
					
					try {
						const variants = productJSON.variants || [];
						const initialVariant = variants.find(v => v.id === parseInt(upsellItem.dataset.selectedVariantId))
							|| variants.find(v => v.available)
							|| variants[0];
						upsellItem.dataset.selectedVariantId = initialVariant.id;
						
						const shouldUpdateContent = upsellItem.dataset.optionsViewed === 'true' || upsellItem.dataset.hasOneVariant === 'true';
						if (initialVariant && selectOptionText && initialVariant.title && shouldUpdateContent) {
							selectOptionText.textContent = initialVariant.title;
						}
						
						this.setupObservers(sectionToInit, upsellItem);
						
						sectionToInit.querySelectorAll('select[name="id"]').forEach(select => {
							select.addEventListener('change', (e) => {
								const variant = e.detail;
								
								if (addToCartBtn) {
									if (variant && variant.available) {
										addToCartBtn.innerHTML = theme.strings.buttonDefault;
									} else {
										addToCartBtn.innerHTML = variant ? theme.strings.buttonNoStock : theme.strings.buttonNoVariant;
									}
								}
								
								if (variant && externalImage) {
									const selectedOption = select.querySelector('option[value="' + variant.id + '"]');
									let testImageUrl = null;
									
									if (selectedOption) {
										testImageUrl = selectedOption.getAttribute('data-test-image-url');
									}
									
									if (testImageUrl && testImageUrl.trim() !== '') {
										externalImage.src = testImageUrl;
									} else if (variant.featured_media) {
										externalImage.src = theme.Shopify.formatImage(variant.featured_media.preview_image.src, '300x');
									}
								}
								
								if (selectOptionText && variant.title) {
									selectOptionText.textContent = variant.title;
								}
								upsellItem.dataset.selectedVariantId = variant.id;
								this.updateExternalPrice(upsellItem);
								this.sendUpsellEvent(upsellItem, 'upsell_view');
							})
						})
					} catch (error) {
						console.warn('Failed to setup variant logic for product:', productJSON.handle, error);
					}
				}
			}
			
			setupObservers(sectionToInit, upsellItem) {
				const internalPriceArea = sectionToInit.querySelector('.price-area');
				const externalPriceElement = upsellItem.querySelector('.upsell-item__price');
				const internalAtcButton = sectionToInit.querySelector('.product-purchase-form [name="add"]');
				const externalAtcButton = upsellItem.querySelector('.upsell-item__add-to-cart');
				
				if (internalPriceArea && externalPriceElement) {
					const discount = parseFloat(upsellItem.dataset.discountPercentage) || 0;
					
					if (discount === 0) {
						const observer = new MutationObserver((mutationsList) => {
							if (upsellItem.dataset.optionsViewed === 'true' || upsellItem.dataset.hasOneVariant === 'true') {
								this.syncPrice(internalPriceArea, externalPriceElement); // Використовуємо стару добру syncPrice
							}
						});
						
						observer.observe(internalPriceArea, {childList: true, subtree: true, characterData: true});
					}
					
					if (upsellItem.dataset.hasOneVariant === 'true') {
						this.updateExternalPrice(upsellItem);
					}
				}
				
				if (internalAtcButton && externalAtcButton) {
					const buttonObserver = new MutationObserver(() => {
						externalAtcButton.disabled = internalAtcButton.disabled;
					});
					buttonObserver.observe(internalAtcButton, {attributes: true, attributeFilter: ['disabled']});
					externalAtcButton.disabled = internalAtcButton.disabled;
				}
			}
			
			syncPrice(internalPrice, externalPrice) {
				externalPrice.innerHTML = internalPrice.innerHTML;
				if (internalPrice.classList.contains('on-sale')) {
					externalPrice.classList.add('on-sale');
				} else {
					externalPrice.classList.remove('on-sale');
				}
			}
			
			updateExternalPrice(upsellItem) {
				const externalPriceElement = upsellItem.querySelector('.upsell-item__price');
				const internalPriceArea = upsellItem.querySelector('.upsell-item__options-container .price-area');
				if (!externalPriceElement) return;
				
				const discount = parseFloat(upsellItem.dataset.discountPercentage) || 0;
				
				if (discount > 0) {
					const variantId = upsellItem.dataset.selectedVariantId;
					const variant = (upsellItem.productData || upsellItem.baseProductData)?.variants.find(v => v.id == variantId);
					
					if (variant) {
						const oldPrice = variant.price;
						const newPrice = oldPrice * (1 - (discount / 100));
						const oldPriceHtml = theme.Shopify.formatMoney(oldPrice, theme.money_format_with_code_preference);
						const newPriceHtml = theme.Shopify.formatMoney(newPrice, theme.money_format_with_code_preference);
						
						externalPriceElement.innerHTML = `
	          <span class="theme-money">
	           <s style="margin-right: 6px;">${oldPriceHtml}</s>
	           <span class="sale-price" style="color: #af2e2e; font-weight: 600;">${newPriceHtml}</span>
	          </span>
	         `;
					}
				} else if (internalPriceArea) {
					this.syncPrice(internalPriceArea, externalPriceElement);
				}
			}
		}
	);
}